export default __webpack_public_path__ + "static/media/close_blue.29410166.svg";